module.exports = __webpack_public_path__ + "static/ja-ded15f74526acf524beab36f5f3930ae.svg";